"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Progress } from "@/components/ui/progress";
const stats = [{
  value: 100,
  display: "60 FPS",
  label: "Fluid Performance"
}, {
  value: 100,
  display: "4K",
  label: "Ultra Resolution"
}, {
  value: 95,
  display: "20ms",
  label: "Ultra Low Latency"
}];
export default function TheImpactWeMeasure() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="129970" id="gaming-solution-engine" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <h2 className="text-3xl md:text-[42px] font-default font-bold tracking-tight mb-4 text-foreground">
            Built on Gaming Engine Power
          </h2>
          <p className="text-muted-foreground font-default text-lg">
            High-fidelity performance metrics driven by our proprietary real-time rendering pipeline and global spatial computing network.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 max-w-5xl mx-auto">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center relative">
              <div className="text-7xl md:text-8xl font-default font-bold tracking-tighter mb-8 text-primary">
                {stat.display}
              </div>
              
              <div className="w-full max-w-[240px]">
                <Progress value={isVisible ? stat.value : 0} className="h-1 bg-muted/20" />
              </div>
              
              <div className="mt-6 text-sm font-default font-medium tracking-widest text-muted-foreground uppercase">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}